import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import PurchasingReportMiddleware from "../../../../middleware/modules/report/purchasing-report";
import FormPurchasingAllReport from "../../../../components/modules/report/purchasing-report/purchasing";

const mapStateToProps = ({ auth, purchasingReport }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: purchasingReport.isProcessing,
  isError: purchasingReport.isError,
  errorMessage: purchasingReport.errorMessage,
  datalist: purchasingReport.data,
  isSuccess: purchasingReport.isSuccess,
  isReset: purchasingReport.isReset,
  isNewRecord: purchasingReport.isNewRecord,
  onSubmit: purchasingReport.onSubmit,
  helperPurchasingReport: purchasingReport.helperPurchasingReport,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setData: (data) => PurchasingReportMiddleware.list(data),
    },
    dispatch
  );
};
class PurchasingAllReport extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    datalist: PropTypes.any,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      show: 0,
    };
    this.setData = this.setData.bind(this);
  }

  setData() {
    this.props.setData();
  }


  render() {
    const { show, datalist } = this.props
    this.state.show = show;
    return (
      <Fragment>
        <FormPurchasingAllReport
          {...this.props}
          data={datalist}
        />
      </Fragment>

    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchasingAllReport);
